/*
 * 客户详情
 *
 * *
 * */
import { GetCustomerDetailReq } from "@/pbjs/external/ticket/collection_pb";
import { collectionServiceClient } from "@/api/index";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
    UserGroupId?: number;
    PayrollCycleCondition?: number;
    IsNewEmployee?: number;
    EmployeeId?: string;
    EmployeeName?: string;
    Page: Page;
    systemtype?:number;
}
export function setGetCustomerDetailReq(arg: any) {
    let request: any = new GetCustomerDetailReq();
    request.setAccountid(arg.id);
    request.setSystemtype(arg.systemtype);
    request.setPagein(setPage(arg.pageIndex, arg.pageSize));
    request.setAppname(arg.appname);
    return request;
}
export const getCustomerDetailRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getCustomerDetail
);
